import React from 'react';
import classNames from 'classnames';
import InfoTooltip from 'components/shared/InfoTooltip';
import { Icon } from 'ui';
import { Text, TEXT_VARIANTS, TEXT_COLORS } from 'ui/Typography';
import { hasFeatureFlags } from 'utils/features';

const PracticeTitle = ({ isGradable }) => (
  <Text className="m-w-fill" variant={TEXT_VARIANTS.TITLE_BOLD}>
    {isGradable ? (
      <span className="d-f ai-c mt-32">
        <Icon name="checklist" className="mr-8" />
        {t('questions.question.evaluation_title')}
      </span>
    ) : (
      <span className="d-f ai-c mt-32">
        <Icon name="rocket_unfilled" className="mr-8" />
        {t('questions.question.practice_title')}
      </span>
    )}
  </Text>
);

const QuestionElementPrompt = props => {
  const {
    isGradable = false,
    isPractice = false,
    elementHeaderClass,
    required,
    labelErrorClass,
    questionSubjectClass,
    subject,
    questionType = '',
    hasAutomatedAnalysis,
  } = props;
  const showNewHeader =
    (questionType === 'upload_response' || questionType === 'free_response') &&
    isGradable;
  const showTopBorder =
    questionType !== 'written_response' &&
    questionType !== 'webcam_recording' &&
    questionType !== 'free_response' &&
    questionType !== 'zendesk' &&
    questionType !== 'screen_recording' &&
    questionType !== 'audio_recording';

  const multilanguageAutomatedAnalysisEnabled = hasFeatureFlags([
    'readiness-enable-automated-multilanguage-assesment',
  ]);

  const gradedTooltip = multilanguageAutomatedAnalysisEnabled
    ? t('automated_analysis.learner_explanation.tooltip.graded_multilingual')
    : t('automated_analysis.learner_explanation.tooltip.graded');

  const nonGradedTooltip = multilanguageAutomatedAnalysisEnabled
    ? t(
        'automated_analysis.learner_explanation.tooltip.non_graded_multilingual',
      )
    : t('automated_analysis.learner_explanation.tooltip.non_graded');

  const renderHeader = () => {
    if (!isPractice && !showNewHeader) {
      return (
        <div className={`QuestionElementPrompt ${elementHeaderClass}`}>
          {required && (
            <span
              data-behavior="required_question"
              className={classNames(
                'Label Label-required QuestionElement-label',
                labelErrorClass,
              )}
            >
              <Icon name="required" className="mr-4" />
              {t('common.required')}
            </span>
          )}
          <h3 className={questionSubjectClass}>{subject}</h3>
        </div>
      );
    }
    return (
      <div
        className={classNames('QuestionElementPrompt pt-12', {
          'QuestionElement-newHeader': showTopBorder,
          'QuestionElement-header': !showTopBorder,
        })}
      >
        <div className="d-f w-fill jc-sb ai-fe fw-w">
          <PracticeTitle isGradable={isGradable} />
          {(isGradable || required || hasAutomatedAnalysis) && (
            <div className="d-f fd-c m-w-fill m-ai-fs ai-fe">
              {required && (
                <div className="d-f jc-e mt-8">
                  <span
                    data-behavior="required_question"
                    className={classNames(
                      'Label Label-required QuestionElement-label',
                      labelErrorClass,
                    )}
                  >
                    <Icon name="required" className="mr-4" />
                    {t('common.required')}
                  </span>
                </div>
              )}
              <div className="d-f ai-c df-r">
                {isGradable && (
                  <Text
                    className={classNames(
                      'bg-secondary bdrs-base p-4 mt-8 w-fc',
                      {
                        'mr-8': hasAutomatedAnalysis,
                      },
                    )}
                    variant={TEXT_VARIANTS.TAG_BOLD_ON_DARK}
                    color={TEXT_COLORS.ON_SECONDARY}
                  >
                    {t('questions.question.graded_response')}
                  </Text>
                )}
                {hasAutomatedAnalysis && (
                  <div className="d-f">
                    <Text
                      variant={TEXT_VARIANTS.TAG_BOLD_ON_DARK}
                      color={TEXT_COLORS.ON_SECONDARY}
                      className="bg-secondary bdrs-base p-4 mt-8 d-f ai-c df-r"
                    >
                      {t('automated_analysis.automated_analysis_overall.title')}
                      <InfoTooltip
                        overrideColorOnSecondary
                        noMarginTop
                        placement="bottom"
                        className="pl-4 tooltip-fixedWidth"
                        tooltip={isGradable ? gradedTooltip : nonGradedTooltip}
                      />
                    </Text>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <hr className="border-gray-light" />
        <Text
          className={questionSubjectClass}
          variant={TEXT_VARIANTS.TITLE_BOLD}
        >
          {subject}
        </Text>
      </div>
    );
  };
  return <>{renderHeader()}</>;
};

export default QuestionElementPrompt;
